import React from "react";
import {BatchProcesses} from "../components/BatchProcesses";

export const BatchProcessesPage = () => {

    return  (
        <div>
            <BatchProcesses />
        </div>
    )

}